export const US_HOTLINES = [
  { name: 'Emergency', number: '911', description: 'For immediate emergencies', canCall: true, canText: false, color: '#E53935' },
  { name: '988 Suicide & Crisis Lifeline', number: '988', description: 'Call/Text 988 • 24/7 support', canCall: true, canText: true, chatUrl: 'https://988lifeline.org/chat', color: '#E85D75' },
  { name: 'Veterans Crisis Line', number: '988', description: 'Call 988 press 1 • Text 838255', canCall: true, canText: true, textNumber: '838255', chatUrl: 'https://www.veteranscrisisline.net', color: '#1565C0' },
  { name: 'Lifeline en Español', number: '1-888-628-9454', description: 'Spanish language crisis support', canCall: true, canText: false, color: '#FB8C00' },
  { name: 'Crisis Text Line', number: '741741', description: 'Text HOME to 741741', canCall: false, canText: true, chatUrl: 'https://www.crisistextline.org', color: '#7C5CBF' },
  { name: 'The Trevor Project (LGBTQ+ youth)', number: '1-866-488-7386', description: 'Text START to 678678', canCall: true, canText: true, textNumber: '678678', chatUrl: 'https://www.thetrevorproject.org/get-help', color: '#9C27B0' },
  { name: 'Trans Lifeline', number: '1-877-565-8860', description: 'Support for trans community (US/CA)', canCall: true, canText: false, color: '#00BCD4' },
  { name: 'RAINN (Sexual Assault)', number: '1-800-656-4673', description: 'Sexual assault support', canCall: true, canText: false, chatUrl: 'https://hotline.rainn.org/online', color: '#00897B' },
  { name: 'National Domestic Violence Hotline', number: '1-800-799-7233', description: 'Text START to 88788', canCall: true, canText: true, textNumber: '88788', chatUrl: 'https://www.thehotline.org', color: '#F5A623' },
  { name: 'Maternal Mental Health Hotline', number: '1-833-943-5746', description: 'Postpartum support - call/text', canCall: true, canText: true, color: '#EC407A' },
  { name: 'SAMHSA Disaster Distress', number: '1-800-985-5990', description: 'Text TalkWithUs to 66746', canCall: true, canText: true, textNumber: '66746', color: '#5C6BC0' },
  { name: 'NAMI HelpLine', number: '62640', description: 'Text "HelpLine" to 62640', canCall: false, canText: true, chatUrl: 'https://www.nami.org/help', color: '#26A69A' },
  { name: '2-1-1 Local Resources', number: '211', description: 'Local community resources', canCall: true, canText: true, chatUrl: 'https://www.211.org', color: '#42A5F5' },
];

export const CANADA_HOTLINES = [
  { name: 'Emergency', number: '911', description: 'For immediate emergencies', canCall: true, canText: false, color: '#E53935' },
  { name: '988 Suicide Crisis Helpline (CA)', number: '988', description: 'Call/Text 988', canCall: true, canText: true, color: '#E85D75' },
  { name: 'Talk Suicide Canada', number: '1-833-456-4566', description: 'Text 45645 (4pm-12am ET)', canCall: true, canText: true, textNumber: '45645', chatUrl: 'https://talksuicide.ca', color: '#7B1FA2' },
  { name: 'Kids Help Phone (≤29)', number: '1-800-668-6868', description: 'Text CONNECT to 686868', canCall: true, canText: true, textNumber: '686868', chatUrl: 'https://kidshelpphone.ca', color: '#FF7043' },
  { name: 'Hope for Wellness (Indigenous)', number: '1-855-242-3310', description: 'Indigenous wellness support', canCall: true, canText: false, chatUrl: 'https://www.hopeforwellness.ca', color: '#8D6E63' },
  { name: 'Indian Residential Schools Crisis', number: '1-866-925-4419', description: '24/7 crisis support', canCall: true, canText: false, color: '#795548' },
  { name: 'MMIWG Crisis Line', number: '1-844-413-6649', description: 'Missing/Murdered Indigenous Women', canCall: true, canText: false, color: '#A1887F' },
  { name: 'Black Youth Helpline', number: '1-833-294-8650', description: 'Support for Black youth', canCall: true, canText: true, textNumber: '1-647-557-5882', color: '#424242' },
  { name: 'Connex Ontario', number: '1-866-531-2600', description: 'MH/Addiction/Gambling support', canCall: true, canText: false, chatUrl: 'https://www.connexontario.ca', color: '#00ACC1' },
];

export const TWELVE_STEP_GROUPS = [
  { name: 'Alcoholics Anonymous (AA)', url: 'https://www.aa.org/find-aa', description: 'Find AA meetings' },
  { name: 'Narcotics Anonymous (NA)', url: 'https://na.org/meetingsearch/', description: 'Find NA meetings' },
  { name: 'Cocaine Anonymous (CA)', url: 'https://ca.org/meetings/', description: 'Find CA meetings' },
  { name: 'Crystal Meth Anonymous (CMA)', url: 'https://crystalmeth.org/meetings/', description: 'Find CMA meetings' },
  { name: 'Marijuana Anonymous (MA)', url: 'https://marijuana-anonymous.org/find-a-meeting/', description: 'Find MA meetings' },
  { name: 'Overeaters Anonymous (OA)', url: 'https://oa.org/find-a-meeting/', description: 'Find OA meetings' },
  { name: 'Sex Addicts Anonymous (SAA)', url: 'https://saa-recovery.org/meetings/', description: 'Find SAA meetings' },
  { name: 'Sex and Love Addicts Anonymous (SLAA)', url: 'https://slaafws.org/meetings/', description: 'Find SLAA meetings' },
  { name: 'Adult Children of Alcoholics (ACA)', url: 'https://adultchildren.org/meeting-search/', description: 'Find ACA meetings' },
  { name: 'Gamblers Anonymous (GA)', url: 'https://www.gamblersanonymous.org/ga/meetings', description: 'Find GA meetings' },
  { name: 'Dual Recovery Anonymous (DRA)', url: 'https://draonline.org/meetings', description: 'Find DRA meetings' },
  { name: 'Emotions Anonymous (EA)', url: 'https://emotionsanonymous.org/ea-meetings.html', description: 'Find EA meetings' },
];

export const ALTERNATIVE_GROUPS = [
  { name: 'SMART Recovery', url: 'https://www.smartrecovery.org/local/', description: 'Science-based recovery' },
  { name: 'Refuge Recovery', url: 'https://refugerecovery.org/meetings', description: 'Buddhist-inspired recovery' },
  { name: 'Dharma Recovery', url: 'https://www.dharmarecovery.org/find-a-meeting', description: 'Mindfulness-based recovery' },
  { name: 'Women for Sobriety', url: 'https://womenforsobriety.org/meetings/', description: 'Women-focused recovery' },
  { name: 'Celebrate Recovery', url: 'https://celebraterecovery.com/locator', description: 'Faith-based recovery' },
];

export const PROFESSIONAL_HELP = [
  { name: 'Find a Therapist', url: 'https://www.psychologytoday.com/us/therapists', description: 'Psychology Today directory', icon: 'person' },
  { name: 'Find Support Groups', url: 'https://www.psychologytoday.com/us/groups', description: 'Local support groups', icon: 'people' },
  { name: 'Find a Psychiatrist', url: 'https://www.psychologytoday.com/us/psychiatrists', description: 'Medication management', icon: 'medkit' },
];

export const AFFIRMATIONS = [
  'You are safe right now.',
  'This feeling will pass.',
  'You are not alone.',
  'Take it one breath at a time.',
  'You have survived difficult moments before.',
  'You are worthy of care and support.',
  'You are stronger than you know.',
  'It\'s okay to ask for help.',
];

export const DEFAULT_SAFETY_PLAN = {
  emotionalWarningSigns: [],
  physicalWarningSigns: [],
  behavioralWarningSigns: [],
  situationalWarningSigns: [],
  environmentalTriggers: [],
  emotionalTriggers: [],
  physicalTriggers: [],
  socialTriggers: [],
  cognitiveTriggers: [],
  internalStrategies: [],
  trustedContacts: [],
  professionalContacts: [],
  safePlaces: [],
  meansReduction: [],
  exitPlans: [],
  reflectionPrompts: [],
  followUpHabits: [],
  reconnectionActivities: [],
  warningSigns: [],
  socialDistractors: [],
  reasonsToLive: [],
  safeEnvironmentSteps: [],
};

